import { Box } from '@mui/material';
import { forwardRef } from 'react';
import type { VideoProps } from './Video.types';

/**
 * Video component for Non Shopify related videos (e.g. Sanity) that accepts an array of sources
 * and optional video props
 * For Shopify related videos, use the Video component from @shopify/hydrogen
 * @param sources - Array of video sources
 * @param videoProps - Optional video props
 * @param captionsFilePath - Optional path to captions file
 */
export const Video = forwardRef<HTMLVideoElement, VideoProps>(function Video(
  { sources, captionsFilePath, ...videoProps },
  ref,
) {
  return sources.length ? (
    <Box component="video" width="100%" maxWidth="100%" {...videoProps} ref={ref}>
      {/* Sources */}
      {sources.map((source, index) => {
        const key = source.src.replace(/[^a-zA-Z0-9]/g, '').slice(0, 10) + index;
        return <source key={key} src={source.src} type={source.type} />;
      })}

      {/* Caption track */}
      {captionsFilePath && <track src={captionsFilePath} kind="captions" srcLang="en" label="English" />}
    </Box>
  ) : null;
});
